import { useState, useEffect } from 'react';
const CountAnimation = ({ targetCount }) => {
    const [count, setCount] = useState(0);
    useEffect(() => {
      const increment = Math.ceil(targetCount / 100);
  
      const interval = setInterval(() => {
        setCount((prevCount) => {
          if (prevCount + increment >= targetCount) {
            clearInterval(interval);
            return targetCount;
          }
          return prevCount + increment;
        });
      }, 50);
  
      return () => clearInterval(interval);
    }, [targetCount]);
  
    return count;
  };

export default CountAnimation